const Tasks = () => import(/* webpackChunkName: "v-gateway-diagnostic" */ '@/components/page/gateway/diagnostic/Tasks')
const Snmp = () => import(/* webpackChunkName: "v-gateway-diagnostic" */ '@/components/page/gateway/diagnostic/Snmp')
const Events = () => import(/* webpackChunkName: "v-gateway-diagnostic" */ '@/components/page/gateway/diagnostic/Events')
const NetworkEvents = () => import(/* webpackChunkName: "v-gateway-diagnostic" */ '@/components/page/gateway/diagnostic/NetworkEvents')

const routes = [
  {
    path: 'tasks',
    name: 'gatewayTasks',
    component: Tasks,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'diagnostic'
    }
  }, {
    path: 'snmp',
    name: 'gatewaySnmp',
    component: Snmp,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'diagnostic'
    }
  }, {
    path: 'events',
    name: 'gatewayEvents',
    component: Events,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'diagnostic'
    }
  }, {
    path: 'network-events',
    name: 'gatewayNetworkEvents',
    component: NetworkEvents,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'diagnostic'
    }
  }
]

export default routes
